<div class="home-page">
  @if (isLoading()) {
    <yds-spinner [label]="'Gegevens laden...'" />
  } @else {
    <h2 class="gl-page__title">Tenant</h2>
    <nav class="home-jump-links">
      <a href="#laatste-salarisverwerkingsrun" (click)="scrollToSection('laatste-salarisverwerkingsrun', $event)">Laatste salarisverwerkingsrun</a>
      <a href="#journaalpostverwerking" (click)="scrollToSection('journaalpostverwerking', $event)">Laatste journaalpostverwerking per instelling</a>
    </nav>
    <yds-card>
      @if (tenants().length > 0) {
        @for (tenant of tenants(); track tenant.tenantId) {
          <section class="home-tenant">
            <dl class="home-def">
              <div class="home-def__row">
                <dt>Naam</dt>
                <dd>{{ tenant.tenantName }}</dd>
              </div>
              <div class="home-def__row">
                <dt>Tenant Id</dt>
                <dd>{{ tenant.tenantCode }}</dd>
              </div>
              <div class="home-def__row">
                <dt>Instapstatus voor kbj</dt>
                <dd>{{ onboardingStatus(tenant.tenantCode) }}</dd>
              </div>
            </dl>

            @for (client of tenant.payrollClients; track client.payrollClientId) {
              <div class="home-client">
                <h3 class="home-client__title">Opdrachtgever</h3>
                <dl class="home-def">
                  <div class="home-def__row">
                    <dt>Naam</dt>
                    <dd>{{ client.payrollClientName }}</dd>
                  </div>
                  <div class="home-def__row">
                    <dt>Code</dt>
                    <dd>{{ client.payrollClientCeanr }}</dd>
                  </div>
                </dl>

                <h4 class="home-institutions__title">Instellingen</h4>
                <yds-table
                  [embedded]="true"
                  [columns]="institutionColumns"
                  [items]="institutionRows(client.payrollClientId, client.institutions)"
                  [zebra]="true"
                  [dottedColumns]="true"
                  (sortChange)="onInstitutionSort(client.payrollClientId, $event)"
                />
              </div>
            }
          </section>
        }
      } @else {
        <p class="home-card__empty">Geen tenantgegevens beschikbaar.</p>
      }
    </yds-card>

    <h2 id="laatste-salarisverwerkingsrun" class="gl-page__title">Laatste salarisverwerkingsrun</h2>
    <yds-card>
      @if (latestImportRuns().length > 0) {
        <yds-table
          [embedded]="true"
          [columns]="importRunColumns"
          [items]="importRunRows()"
          [zebra]="true"
          [dottedColumns]="true"
          (sortChange)="onImportRunSort($event)"
        />
      } @else {
        <p class="home-card__empty">Geen salarisverwerkingen beschikbaar.</p>
      }
    </yds-card>

    <h2 id="journaalpostverwerking" class="gl-page__title">Laatste journaalpostverwerking per instelling</h2>
    <yds-card>
      @if (latestPlanningRecords().length > 0) {
        <yds-table
          [embedded]="true"
          [columns]="planningRecordColumns"
          [items]="planningRecordRows()"
          [zebra]="true"
          [dottedColumns]="true"
          (sortChange)="onPlanningRecordSort($event)"
        />
      } @else {
        <p class="home-card__empty">Geen journaalpostverwerkingen beschikbaar.</p>
      }
    </yds-card>
  }
</div>
